import { Pipe, PipeTransform } from '@angular/core';
import {ShopUtils} from '../utils/shop-utils.class';

@Pipe({
  name: 'personFormat'
})
export class PersonFormatPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (args === 'sex'){
      switch (value) {
        case 1:
          return 'Nam';
        case 0:
          return 'Nữ';
        case 2:
          return 'KXĐ';
        default:
          return '';
      }
    } else {
      if (value) {
        return value.ho + ' ' + value.ten;
      }
      return '';
    }
  }
  transformSex(value: number): any {
    switch (value) {
      case 1:
        return 'Nam';
      case 0:
        return 'Nữ';
      case 2:
        return 'KXĐ';
      default:
        return '';
    }
  }
}
